import React, { useState, useRef, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ReactPlayer from 'react-player'
import { NavLink } from "react-router-dom";
import axios from 'axios';
import { Next } from "react-bootstrap/esm/PageItem";


function VideoPage(props, cubedotsId) {
    var [dataSet, setDataSet] = useState({})
    const playerRef = useRef(null);


    useEffect(() => {
        if (dataSet.type != props.cubedotsId) {
            fetchTemaMap(props.cubedotsId)
        }
    }, [])

    async function fetchTemaMap(cubedotsId) {
        try {
            const res = await axios.get("assets/data/video.json");
            const tempOutputData = res.data;

            tempOutputData["Sheet1"].forEach(obj => {
                const cubedots_id = obj["cubedotsId"];
                const link = obj["Link"];

                tempOutputData[cubedots_id] = {
                    "video": obj["video"],
                    "Living": obj["Living"],
                    "Balcony": obj["Balcony"],
                    "Dining": obj["Dining"],
                    "Kitchen": obj["Kitchen"],
                    "Corridor": obj["Corridor"],
                    "Normal Bedroom 01": obj["Normal Bedroom 01"],
                    "Normal Bathroom 01": obj["Normal Bathroom 01"],
                    "Master Bedroom": obj["Master Bedroom"],
                    "Master Bathroom": obj["Master Bathroom"],
                    "Normal Bedroom 02": obj["Normal Bedroom 02"],
                    "Common Bathroom": obj["Common Bathroom"],
                    // "Scene Name": obj["Scene Name"],
                    // "Apartment Type": obj["Apartment Type"],
                };
            });

            const dt = {
                "type": cubedotsId,
                "data": res.data,
                "video": null,
                "itemList": []
            }
            let newObje = res.data[cubedotsId];
            for (let key in newObje) {
                if (newObje[key] === "null") {
                    delete newObje[key];
                }
            }

            Object.keys(newObje).forEach(function (key) {
                if (key === "video") {
                    dt.video = newObje[key]
                    props.onVideoChange(dt.video);
                } else {
                    var cal = newObje[key].split(":")
                    var total = 0.0
                    if (cal.length === 3) {
                        total = parseInt(cal[0]) * 60 * 60
                        total += parseInt(cal[1]) * 60
                        total += parseInt(cal[2])
                    } else if (cal.length === 2) {
                        total += parseInt(cal[0]) * 60
                        total += parseInt(cal[1])
                    } else if (cal.length === 1) {
                        total += parseInt(cal[0])
                    }
                    // }

                    dt.itemList.push(<li><button id={"dddd" + key} onClick={() => onclick(key, total)} >{key}</button></li>)
                }
            })
            setDataSet(dt)
        } catch (error) {
            console.error("error ", error);
        }
    }
    function onclick(key, value) {
        try {
            playerRef.current.seekTo(parseFloat(value));
        } catch (error) {
            console.error("Error in onclick:", error);
        }
    }
    const seekToStart = () => {
        playerRef.current.seekTo(0);
    };
    return (
        dataSet.type != null ?
            <>
                <div >
                    <Modal  {...props} className="videoPageModalSection">
                        <Modal.Header closeButton>
                        </Modal.Header>
                        <Modal.Body className="videoPageBody">
                            <ReactPlayer
                                className='react-player'
                                playing={true}
                                autoPlay={true}
                                width='100%'
                                height='100%'
                                seekToStart={seekToStart}
                                ref={playerRef}
                                controls={true}
                                loop={true}
                                url={dataSet.video}
                            />
                            <div>
                                <ul>
                                    {dataSet.itemList}
                                </ul>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </> : null
    )
}
export default VideoPage;